module.exports = __webpack_public_path__ + "img/area-part4-121.bea0ae32.png";